const defaultConfig = {
  formClass: 'Filters__Form',
  activeFiltersClass: 'Filters__ActiveFilters',
  activeFilterClass: 'Filters__ActiveFilter',
  activeFilterTextClass: 'Filters__ActiveFilter__Label',
  activeFilterRemoveClass: 'Filters__ActiveFilter__Remove',
  activeFilterTemplateClass: 'Filters__ActiveFilterTemplate',
  clearFiltersButtonClass: 'Filters__ClearButton',
  clearFiltersTemplateClass: 'Filters__ClearButtonTemplate',
  onChange: () => {}
};

/**
 * @param {HTMLElement} $element
 * @param {Object} options
 * @param {String} options.formClass
 * @param {String} options.activeFiltersClass
 * @param {String} options.activeFilterClass
 * @param {String} options.activeFilterTextClass
 * @param {String} options.activeFilterRemoveClass
 * @param {String} options.activeFilterTemplateClass
 * @param {String} options.clearFiltersButtonClass
 * @param {String} options.clearFiltersTemplateClass
 * @param {Function} options.onChange
 */
export function initializeFilters($element, options={}) {
  options = Object.assign({}, defaultConfig, options);
  const context = getContext($element, options);
  if (!context) {
    return;
  }

  let activeFilters = getActiveFiltersFromUrl();
  renderFilters(context, activeFilters);

  const {
    $filtersForm,
    $activeFilters
  } = context;

  // Update filters when checkboxes in the filter dropdowns are changed.
  $filtersForm.addEventListener('change', event => {
    const { name, checked } = event.target;
    if (checked) {
      activeFilters.set(name, true);
    } else {
      activeFilters.delete(name);
    }
    renderFilters(context, activeFilters);
    options.onChange({
      filters: activeFilters,
      updateHistory: true
    });
  }, { capture: true });

  // Update filters when active filters are removed or all are cleared.
  $activeFilters.addEventListener('click', async event => {
    if (event.target.classList.contains(options.activeFilterRemoveClass)) {
      const $activeFilter = event.target.closest(`.${options.activeFilterClass}`);
      const filterKey = $activeFilter.querySelector(`.${options.activeFilterTextClass}`).textContent;
      activeFilters.delete(filterKey);
      renderFilters(context, activeFilters);
      options.onChange({
        filters: activeFilters,
        updateHistory: true
      });
    } else if (event.target.classList.contains(options.clearFiltersButtonClass)) {
      activeFilters = new Map();
      resetFilters(context);
      renderFilters(context, activeFilters);
      options.onChange({
        filters: activeFilters,
        updateHistory: true
      });
    }
  });

  // Update filters when navigating browser history.
  window.addEventListener('popstate', () => {
    activeFilters = getActiveFiltersFromUrl();
    renderFilters(context, activeFilters);
    options.onChange({
      filters: activeFilters,
      updateHistory: false
    });
  });
}

function getContext($element, options={}) {
  const $filtersForm = $element.querySelector(`.${options.formClass}`);
  const $activeFilters = $element.querySelector(`.${options.activeFiltersClass}`);
  const $activeFilterTemplate = $element.querySelector(`.${options.activeFilterTemplateClass}`);
  const $clearFiltersTemplate = $element.querySelector(`.${options.clearFiltersTemplateClass}`);

  if (!$filtersForm || !$activeFilters || !$activeFilterTemplate || !$clearFiltersTemplate) {
    return null;
  }

  return {
    $element,
    $filtersForm,
    $activeFilters,
    $activeFilterTemplate,
    $clearFiltersTemplate,
    options
  }
}

function getActiveFiltersFromUrl() {
  const filters = new Map();
  const url = new URL(location.href);
  url.searchParams.forEach((filterValue, filterKey) => {
    filters.set(filterKey, true);
  });
  return filters;
}

function renderFilters(context, filters) {
  const { $activeFilters } = context;

  $activeFilters.innerHTML = '';
  resetFilters(context);

  if (filters.size > 0) {
    const elements = [];
    for (const filterKey of filters.keys()) {
      elements.push(getActiveFilterElement(context, filterKey));
      toggleFilter(context, filterKey, true);
    }
    elements.push(getClearFiltersElement(context));

    for (const $element of elements) {
      $activeFilters.appendChild($element);
    }
  }
}

function getActiveFilterElement(context, filterKey) {
  const { $activeFilterTemplate, options } = context;
  const $activeFilter = $activeFilterTemplate.content.cloneNode(true);
  $activeFilter.querySelector(`.${options.activeFilterTextClass}`).textContent = filterKey;
  return $activeFilter;
}

function getClearFiltersElement(context) {
  const { $clearFiltersTemplate } = context;
  return $clearFiltersTemplate.content.cloneNode(true);
}

function toggleFilter(context, filterKey, active) {
  const { $filtersForm } = context;
  const $filterInput = $filtersForm.querySelector(`[name="${filterKey}"]`);
  $filterInput.checked = active;
}

function resetFilters(context) {
  const { $filtersForm } = context;
  $filtersForm.reset();
}
